 <div class="card" [ngClass]="{ 'card-content': templateForPermitForm }">
      <div class="card-body">
<div class="row">
  <div class="col-sm">
    <ul
      ngbNav
      #tabs="ngbNav"
      class="nav-tabs"
      (navChange)="onSearchMapTabChange($event)"
      [destroyOnHide]="true"
       [class.permit-blue-tabs]="templateForPermitForm"
    >
<li ngbNavItem="searchTab" id="searchTab">
  <a ngbNavLink>Search</a>

  <ng-template ngbNavContent>
    <div class="row search-row flex-fill">
      <div class="col-sm">

        <form
          [formGroup]="form"
          (submit)="submitSearchParcelDataCriteria($event)"
        >

          @if (!templateForPermitForm) {

                     <ng-container formGroupName="searchParcelDataCriteria">
                        <div class="form-group">
                          <label for="parcelIdSearch" class="bmd-label-static">
                            Parcel ID:
                          </label>
                          <input
                            id="parcelIdSearch"
                            type="text"
                            class="form-control"
                            formControlName="searchParcelId"
                            [(ngModel)]="
                              searchParcelDataCriteria.searchParcelId
                            "
                          />
                        </div>
                        <div class="form-group">
                          <label
                            for="parcelOwnerSearch"
                            class="bmd-label-static"
                          >
                            Property Owner:
                          </label>
                          <input
                            id="parcelOwnerSearch"
                            type="text"
                            class="form-control"
                            formControlName="searchParcelOwnerName"
                            [(ngModel)]="
                              searchParcelDataCriteria.searchParcelOwnerName
                            "
                          /><br />
                        </div>
                        <div class="form-group">
                          <label
                            for="propertyAddressSearch"
                            class="bmd-label-static"
                          >
                            Property Address:
                          </label>
                          <input
                            id="propertyAddressSearch"
                            type="text"
                            class="form-control"
                            formControlName="searchParcelAddress"
                            [(ngModel)]="
                              searchParcelDataCriteria.searchParcelAddress
                            "
                          />
                        </div>
                      </ng-container>
                      <button
                        type="submit"
                        class="btn btn-primary btn-raised"
                        [disabled]="
                          !(
                            searchParcelDataCriteria.searchParcelAddress ||
                            searchParcelDataCriteria.searchParcelOwnerName ||
                            searchParcelDataCriteria.searchParcelId
                          )
                        "
                        (click)="submitSearchParcelDataCriteria($event)"
                      >
                        Search
                      </button>

          }

          @else {
 <ng-container formGroupName="searchParcelDataCriteria">
            <div class="mt-4">


              <div class="row align-items-end mb-3">
                <div class="col-12 col-md-8 col-lg-10">
                  <wm-common-textfield
                    [data]="{
                      label: 'Parcel ID',
                      id: 'parcelIdSearch'

                    }"
                       formControlName="searchParcelId"
                            [(ngModel)]="
                              searchParcelDataCriteria.searchParcelId
                            "
                    >
                  </wm-common-textfield>
                </div>
              </div>


              <div class="row align-items-end mb-3">
                <div class="col-12 col-md-8 col-lg-10">
                  <wm-common-textfield
                    [data]="{
                      label: 'Property Owner',
                      id: 'parcelOwnerSearch'
                    }"

                     formControlName="searchParcelOwnerName"
                            [(ngModel)]="
                              searchParcelDataCriteria.searchParcelOwnerName
                            "
                    >
                  </wm-common-textfield>
                </div>
              </div>

              <div class="row align-items-end mb-3">
                <div class="col-12 col-md-8 col-lg-10">
                  <wm-common-textfield
                    [data]="{
                      label: 'Property Address',
                      id: 'propertyAddressSearch'
                    }"
                     formControlName="searchParcelAddress"
                            [(ngModel)]="
                              searchParcelDataCriteria.searchParcelAddress
                            "
                    >
                  </wm-common-textfield>
                </div>
              </div>

              <div class="row">
                <div class="col-12 col-md-4 col-lg-3">
                  <wm-common-button
                   class="btn-search"
                    [data]="{
                      text: 'Search',
                      type: 'submit',
                      disabled: !(
                        searchParcelDataCriteria.searchParcelAddress ||
                        searchParcelDataCriteria.searchParcelOwnerName ||
                        searchParcelDataCriteria.searchParcelId
                      ),
                      onClick: submitSearchParcelDataCriteria.bind(this)
                    }">
                  </wm-common-button>
                </div>
              </div>

            </div>
            </ng-container>
          }

        </form>
      </div>
    </div>
  </ng-template>
</li>

      <li ngbNavItem="mapTab" id="mapTab" [disabled]="!activity.model.hasMap">
        <a ngbNavLink>Map</a>
        <ng-template ngbNavContent>
          <div class="tab-pane fade active show" id="mapTab">
            <app-esri-map
              #esriMap
              [mapServiceId]="activity.model.mapConfig.mapServiceId"
              [basemapName]="activity.model.mapConfig.basemapName"
              [initialExtent]="activity.model.mapConfig.initialExtent"
              [mapLayerOptions]="activity.model.mapConfig.layers"
              [showToc]="activity.model.mapConfig.showToc"
              (featuresIdentified)="onParcelsIdentified($event)"
              (featuresBeforeIdentifying)="onParcelsBeforeIdentifying()"
              (mapLoaded)="onMapLoaded()"
              [clearSelection]="false"
              useSketchLayer="false"
              [multiSelect]="true"
            >
            </app-esri-map>
          </div>
        </ng-template>
      </li>
      <li ngbNavItem="myParcelsTab" id="myParcelsTab" [disabled]="!userId">
        <a ngbNavLink>My Parcels</a>
        <ng-template ngbNavContent>
          <div style="border-bottom: 1px solid gray">
            @if(!templateForPermitForm){
            <wm-my-application-parcels
              [userId]="userId"
              (parcelSelected)="myParcelSelected($event)"
              [allowMultiples]="true"
              [formControls]="this.activity.model.selectedParcels"
            ></wm-my-application-parcels>
            }
            @else{
            <wm-my-application-parcels
              [userId]="userId"
              (parcelSelected)="myParcelSelected($event)"
              [allowMultiples]="true"
              [formControls]="this.activity.model.selectedParcels"
              janus="true"
              ></wm-my-application-parcels>
            }
            </div>
        </ng-template>
      </li>
    </ul>
    <div [ngbNavOutlet]="tabs" class="mt-2"></div>
  </div>

</div>
</div>
 <div class="col-sm" [hidden]="!showSelectedParcelCard">
    <!--selected parcels -->

    <div class="col">
      <div class="row">
        <div class="col">
          <div class="card">
            <div class="card-header">Selected Parcels</div>
            <div class="card-body selected-parcels">
            <ng-container
              *ngFor="let s of activity.model.selectedParcels"
            >


              <wm-common-chip
                [data]="{
                  label:  s.parcelID ,
                  color: 'primary',
                  removable: true,
                  id: 'filter-' + s.parcelID
                }"

                (onDelete)="removeFromSelected(s)"
              ></wm-common-chip>

            </ng-container>
          </div>


          </div>
        </div>
      </div>
    </div>
    <!-- end selected parcels -->
  </div>
  <br />
</div>


<div style="height:2rem"><app-loader *ngIf="loading"></app-loader></div>
<div class="row flex-shrink-0" [hidden]="!showSearchResults">
  <!-- Search Results -->
  <div class="col-sm">


  @if(!templateForPermitForm){
    <table
      class="table"
      *ngIf="
        this.parcels &&
        this.parcels.controls &&
        this.parcels.controls.length > 0
      "
    >
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col">Parcel ID</th>
          <th scope="col">Address</th>
          <th scope="col">City</th>
          <th scope="col">Owner Name</th>
          <th scope="col" class="algin-right">Acres</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody [formGroup]="form">
        <ng-container formArrayName="parcels">
          <ng-container *ngFor="let r of parcels.controls; let i = index">
            <tr [ngClass]="{ 'table-active': r.selected }" [formGroup]="r">
              <td>
                <div
                  class="custom-control custom-checkbox"
                  *ngIf="!hideResultsOnSelect"
                >
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    formControlName="selected"
                    [id]="r.value.parcelId"
                    [value]="r.value.selected"
                    (change)="selectOneResult(r, true)"
                  />
                  <label
                    class="custom-control-label"
                    [for]="r.value.parcelId"
                  ></label>
                </div>

                <a
                  *ngIf="hideResultsOnSelect"
                  href="javascript:void(0)"
                  (click)="selectOneResult(r, true, true)"
                >
                  <span *ngIf="isParcelSelected(r)">Selected</span>
                  <span *ngIf="!isParcelSelected(r)">Select</span>
                </a>
              </td>
              <td>{{ r.value.parcelId }}</td>
              <td>{{ r.value.parcel.address }}</td>
              <td>{{ r.value.parcel.city }}</td>
              <td>{{ r.value.parcel.ownerName }}</td>
              <td class="algin-right">
                {{ r.value.parcel.acres * 1 | number: '1.3-3' }}
              </td>

              <td class="algin-right">
                <button
                  type="button"
                  class="btn btn-raised btn-primary float-right notes-button"
                  (click)="parcelNotesModal.open()"
                  *ngIf="
                    !(
                      (r.value.parcel.internalNote == '0' &&
                        r.value.parcel.publicNote == '0' &&
                        !canManageParcelNotes == true) ||
                      (r.value.parcel.publicNote == '0' &&
                        !canViewInternalParcelNotes == true)
                    )
                  "
                >
                  <!--
                    *ngIf ="!(((r.value.parcel.internalNote=='0' && r.value.parcel.publicNote=='0') && !canManageParcelNotes==true)||((r.value.parcel.publicNote=='0') && !canViewInternalParcelNotes==true))"
                  Currently No Notes on the parcel, but I can add some.
                  Currently Either internal or public Notes on the parcel that can be edited
                  Currently Either internal or public Notes on the parcel that can't be edited
                  Currently There are either No Notes on the parcel OR no public notes and you don't have permission to view the internal notes.  --there is no visible button in this case because it won't pass the inIf for the button element.
                -->
                  <span
                    *ngIf="
                      r.value.parcel.internalNote == '0' &&
                      r.value.parcel.publicNote == '0' &&
                      canManageParcelNotes == true
                    "
                    >Add Note</span
                  >
                  <span
                    *ngIf="
                      !(
                        r.value.parcel.internalNote == '0' &&
                        r.value.parcel.publicNote == '0'
                      ) && canManageParcelNotes == true
                    "
                    >Modify Note</span
                  >
                  <span
                    *ngIf="
                      !(
                        r.value.parcel.internalNote == '0' &&
                        r.value.parcel.publicNote == '0'
                      ) && !canManageParcelNotes == true
                    "
                    >View Note</span
                  >
                  <!-- this should stay hidden -->
                  <span
                    *ngIf="
                      (r.value.parcel.internalNote == '0' &&
                        r.value.parcel.publicNote == '0' &&
                        !canManageParcelNotes == true) ||
                      (r.value.parcel.publicNote == '0' &&
                        !canViewInternalParcelNotes == true)
                    "
                    >No Note</span
                  >
                </button>
              </td>
                 <wm-modal-confirm
                title="Parcel Notes"
                [small]="false"
                [showButtonText]="false"
                [showButton]="false"
                commandText="Save"
                (accepted)="
                  notesModal(publicNote, internalNote, r.value.parcel.parcelID)
                "
                (opened)="getParcelNote(r.value.parcel.parcelID)"
                [showCommandButton]="canManageParcelNotes"
                #parcelNotesModal
              >
                <label id="lblParcelID"
                  ><strong>{{ r.value.parcel.parcelID }}</strong></label
                ><br />
                <label id="lblPublicNote">Public Note</label>
                <textarea
                  class="form-control"
                  name="publicNote"
                  id="publicNote"
                  rows="20"
                  aria-describedby="lblPublicNote"
                  formControlName="publicNote"
                  [(ngModel)]="publicNote"
                  [readonly]="!canManageParcelNotes"
                >
                </textarea>
                <!-- TODO: Make sure I check permissions server side, so I don't even return value if I don't have permissions.  -->
                <br />
                <label
                  id="lblInternalNote"
                  *ngIf="canViewInternalParcelNotes == true"
                >
                  Internal Note
                </label>
                <textarea
                  class="form-control"
                  name="InternalNote"
                  id="InternalNote"
                  rows="20"
                  aria-describedby="lblInternalNote"
                  formControlName="internalNote"
                  [(ngModel)]="internalNote"
                  *ngIf="canViewInternalParcelNotes == true"
                  [readonly]="!canManageParcelNotes"
                >
                </textarea>
              </wm-modal-confirm>


            </tr>
          </ng-container>
        </ng-container>
      </tbody>
    </table>

  }
  @else{
        <wm-common-table
  *ngIf="this.parcels.controls && this.parcels.controls.length > 0"
  [columns]="parcelTableColumns"
 [data]="trimmedResults"
  tableClass="table"

  (checkboxSelect)="onParcelRowClick($event)"
>
</wm-common-table>
 <wm-modal-confirm
                title="Parcel Notes"
                [small]="false"
                [showButtonText]="false"
                [showButton]="false"
                commandText="Save"
                (accepted)="
                  notesModal(publicNote, internalNote, selectedParcelForNotes?.parcelId)
                "
                (opened)="getParcelNote(selectedParcelForNotes?.parcelId)"
                [showCommandButton]="canManageParcelNotes"
                #ParcelNotesModal
              >
                <label id="lblParcelID"
                  ><strong>{{ selectedParcelForNotes?.parcelId}}</strong></label
                ><br />

              <wm-common-textfield
                [data]="{
                  label: 'Public Note',
                  textAreaRows: 8,
                  type: 'text-area',
                  readonly: !canManageParcelNotes,
                }"
                [(ngModel)]="publicNote"
                >
              </wm-common-textfield>

              <wm-common-textfield
                *ngIf="canViewInternalParcelNotes"
                [data]="{
                  label: 'Internal Note',
                  textAreaRows: 8,
                  type: 'text-area',
                  readonly: !canManageParcelNotes
                }"
                [(ngModel)]="internalNote"
                >
              </wm-common-textfield>
              </wm-modal-confirm>
  }

  </div>

</div>

<p
  *ngIf="
    !loading &&
    this.parcels &&
    this.parcels.controls &&
    this.parcels.controls.length < 1
  "
>
  No results
</p>